import { Button, Card, Form, Tag, Row, Col, Space, message } from "antd";
import {
  PlusOutlined,
  CheckOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../../../firebase";
import { NavLink } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

const Maintenance = ({ data, title, unitTurnId, type }) => {
  const [user, loading] = useAuthState(auth);
  const [unitTurns, setUnitTurns] = useState([]);
  const [workOrderIds, setWorkOrderIds] = useState([]);
  const [companyName, setCompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);
  console.log("PropertyId", data);

  const createWorkOrder = (category) => {
    window.open(`/maintenance/work-orders/service-requests/new?unit_turn_id=${unitTurnId}&unit_turn_category=${category}&propertyId=${data?.unitId}`, "_blank");
  };
 
  const updateStatus = async (id, status) => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const userRef = collection(companyDocRef, "unitTurns");
      const docRef = doc(userRef, id);
      await updateDoc(docRef, {
        [`maintenance.${type}`]: status,
      });
      console.log("Tenant updated successfully");
      message.success("Tenant Account Profile updated successfully..", 3);
    } catch (error) {
      console.error("Error updating tenant:", error);
      message.success("Error Tenant Account Profile updating.", 3);
    }
  };
  const getWorkOrderById = async (id) => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const userRef = collection(companyDocRef, "newServiceRequest");
    const userData = query(userRef, where("unit_turn_id", "==", id));
    const matchingData = [];
    const matchingIds = [];
    getDocs(userData)
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const res = doc.data();
          matchingData.push(res);
          matchingIds.push(doc.id);
          // console.log("res", res);
        });
        setUnitTurns(matchingData);
        setWorkOrderIds(matchingIds);
        console.log("Matching Data: ", matchingData);
        console.log("IDDDD: ", matchingIds);
      })
      .catch((error) => {
        console.log("Error getting users: ", error);
      });
  };

  useEffect(() => {
    getWorkOrderById(unitTurnId);
    // console.log(unitTurns);
  }, []);
  return (
    <div>
      <Card
        title={title}
        extra={
          <Space>
            {data?.maintenance?.[type] ? (
              <>
                <Tag
                  color="green"
                  icon={<CheckCircleOutlined />}
                  style={{ marginRight: 8 }}
                >
                  Done
                </Tag>
                <NavLink
                  to={`/maintenance/unit-turns/${unitTurnId}`}
                  onClick={() => updateStatus(unitTurnId, false)}
                >
                  Undo
                </NavLink>
              </>
            ) : (
              <Button
                icon={<CheckOutlined />}
                onClick={() => updateStatus(unitTurnId, true)}
              >
                Mark As Done
              </Button>
            )}
            <Button
              icon={<PlusOutlined />}
              onClick={() => createWorkOrder(type)}
            >
              Create Work Orde
            </Button>
          </Space>
        }
      >
        {/* {data?.maintenance?.[type] */}

        <>
          {unitTurns.map((unitTurn, index) =>
            unitTurn?.unit_turn_category == type ? (
              <Card key={index}>
                <Form layout="vertical">
                  <Row justify="space-between">
                    <Col span={8}>
                      <NavLink
                        to={`/maintenance/work-orders/work-order/${workOrderIds[index]}`}
                      >
                        <p>Work Order</p>
                      </NavLink>
                      <Tag style={{ backgroundColor: "black", color: "white" }}>
                        Assigned
                      </Tag>
                    </Col>
                    <Col span={6}>
                      <p>Job Description</p>
                      <p>{unitTurn?.ownerInformation?.description}</p>
                    </Col>
                    <Col span={10}>
                      <p>Scheduled</p>
                      {/* <p>{unitTurn.scheduled}</p> */}
                    </Col>
                  </Row>
                </Form>
              </Card>
            ) : (
              // <p style={{ textAlign: "center" }}>
              //   There are currently no work orders associated with this section
              // </p>
              ""
            )
          )}
        </>
      </Card>
    </div>
  );
};

export default Maintenance;
